function successResult (success, result) {
    return {success, errorMessage: success ? null : typeof result === "object" ? result : {message: result}, result: success ? result : null};
};

export default {
    successResult
}